import { SubscriptionPlan } from "./subscription-plan";
import { SubscriptionStatus } from "./subscription-status";
export class Subscription {
    id:number;
    endedAt:Date;
    canceledAt:Date;
    currentPeriodStart:Date;
    currentPeriodEnd:Date;
    status:SubscriptionStatus;
    quantity:number;
    plan:SubscriptionPlan;
    renewalDate:Date;
    total:number;
    billingInterval:string = "month";

    public isActiveSubscription() {
        if (this.status == SubscriptionStatus.ACTIVE || this.status == SubscriptionStatus.TRIAL) {
            return true;
        }
        if (this.status == SubscriptionStatus.CANCEL_PROCESSING && this.currentPeriodEnd && this.currentPeriodEnd >= new Date()) {
            return true;
        }
        return false;
    }

    public isTrialSubscription() {
        return this.status == SubscriptionStatus.TRIAL || this.status == SubscriptionStatus.TRIAL_PERIOD_ENDED;
    }

    public isUnpaidSubscription() {
        return this.status == SubscriptionStatus.UNPAID || this.status == SubscriptionStatus.PAST_DUE;
    }

    public isEndedSubscription() {
        return this.status == SubscriptionStatus.CANCELED || this.status == SubscriptionStatus.TERMINATED;
    }

    public getChargeDescription() {
        let description = [];
        if (this.isTrialSubscription()) {
            description.push("Free trial ")
        } else {
            // future versions of angular can use formatCurrency in @angular/common
            description.push(this.getTotalCurrency());
            description.push(" per ");
            description.push(this.billingInterval);
        }

        if (this.plan && this.plan.unitType != "Assessments") {
            description.push(" for ");
            description.push(this.quantity);
            description.push(" ");
            // make it singular
            description.push(this.plan.getUnitTypeNameForQuantity(this.quantity));
        }
        return description.join("");
    }

    private getTotalCurrency() {
        if (Intl && Intl.NumberFormat) {
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });
            return formatter.format(this.total);
        } else {
            return "$" + this.total.toFixed(2); // good enough compromise.
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/subscription.ts